import type { NativeRouteMeta } from '@retailer-platform/dashboard/routing-native'
import { autoEnableRouteNames, groupNativeRouteMeta, nativeFileBases } from './nativeDomains'

/**
 * Per-domain native route metadata, grouped from each route's data-only
 * `src/routing/<route>.native.meta.ts` and keyed by domain directory. Eager on purpose: the shell
 * decision and the choice of which domain to load both run before render, so neither can wait on
 * a lazy import — which is also why each file must stay free of runtime imports. Migrating a
 * route adds its own meta file; no shared list is edited.
 */
const sidecars = import.meta.glob<NativeRouteMeta>(
  '../../../domains/*/src/routing/*.native.meta.ts',
  { eager: true, import: 'nativeRouteMeta' }
)

export const NATIVE_ROUTE_META = groupNativeRouteMeta(sidecars)

/** Per domain, the `<base>` of every `<base>.native.meta.ts` (checked against the route files). */
export const NATIVE_META_FILE_BASES = nativeFileBases(Object.keys(sidecars), '.native.meta.ts')

/** Route names whose direct load boots into the TanStack shell. */
export const NATIVE_SHELL_ROUTE_NAMES: readonly string[] = autoEnableRouteNames(NATIVE_ROUTE_META)
